export class WorkflowStepPropertyCodes {
    static readonly STATE = 'state';
    static readonly DATE = 'date';
    static readonly COMPLETED = 'completed';
}
